export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[300px] lg:min-h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20scene%20with%20carefully%20curated%20neutral%20toned%20garments%20and%20accessories%20on%20cream%20backdrop%2C%20soft%20natural%20daylight%2C%20editorial%20photography%2C%20warm%20sand%20and%20taupe%20palette%2C%20high%20detail%2C%20artistic%20composition%2C%20textured%20linen%20fabrics&width=1200&height=900&seq=cta-fashion-v2&orientation=landscape"
          alt="Elegant curated fashion scene with neutral garments"
          title="Unlock Fashion Deals - Pandabuy Sheet"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/25"></div>
        <div className="relative z-10 p-8 md:p-12 flex flex-col justify-end h-full">
          <p className="text-xs text-white/70 font-medium tracking-wide uppercase mb-3">Spreadsheet Library</p>
          <p className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
            Get Your<br />
            Personal<br />
            Pandabuy Sheet
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-16">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-6 leading-tight">
            Unlock Every<br />
            Fashion Deal
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            Access the full Pandabuy Spreadsheet library with real-time price comparisons across all 14 fashion categories. Updated weekly with the latest deals, new arrivals, and trending styles curated by our fashion research team.
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            Whether you are hunting for budget sneakers, premium jackets, or the perfect accessories, our structured comparison tables help you make smarter purchasing decisions in seconds.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
          >
            Visit Kaspreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}